module.exports = __webpack_public_path__ + "static/media/art6.ab15534b.jpg";